var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "btn-group" },
    [
      _vm.canView
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: "Show",
                effect: "light",
                placement: "top-start",
                "open-delay": 300,
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn-sm btn-width-fixed",
                  on: { click: _vm.view },
                },
                [_c("i", { staticClass: "fas fa-info" })]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canEdit
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: "Edit",
                effect: "light",
                placement: "top-start",
                "open-delay": 300,
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn-sm",
                  on: { click: _vm.edit },
                },
                [_c("i", { staticClass: "fas fa-edit" })]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canClone
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: "Clone",
                effect: "light",
                placement: "top-start",
                "open-delay": 300,
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn-sm",
                  on: { click: _vm.clone },
                },
                [_c("i", { staticClass: "fas fa-clone" })]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canCloneWithContacts
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: "Clone & Create ContactList",
                effect: "light",
                placement: "top-start",
                "open-delay": 300,
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn-sm",
                  on: { click: _vm.cloneWithContacts },
                },
                [_c("i", { staticClass: "far fa-clone" })]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canDelete
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: "Delete",
                effect: "light",
                placement: "top-start",
                "open-delay": 300,
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-sm",
                  on: { click: _vm.confirmDeleting },
                },
                [_c("i", { staticClass: "fas fa-trash-alt" })]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }